
// const requsetURL = 'http://10.1.102.238:5555'; // 测试地址。测试地址不要提交代码！！！
const requsetURL = 'https://datago-bj.fupin832.com'; // .生产地址
// const requsetURL = 'http://localhost:5555'; // 本机调试地址。本机调试地址不要提交代码！！！
export default requsetURL ;

